import React from 'react';
import { WarehouseQuoteDetailDataForm, WarehouseQuoteDetailShowDataForm } from '../../../../../../../app/models/WareHouseQuoteDetail';

interface Props {
    quoteDetail: WarehouseQuoteDetailShowDataForm;
}

const WarehouseQuoteDetailShowForm = ({ quoteDetail }: Props) => {
   return (
    <>
      {/* Servicio adicional */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Servicio</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={quoteDetail.service || ''}
            disabled
          />
        </div>
      </div>

      {/* Producto */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Producto</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={quoteDetail.product}
            disabled
          />
        </div>
      </div>

      {/* Fecha Cuota */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Fecha Cuota</label>
        <div className="col-md-9">
          <input
            type="date"
            className="form-control"
            value={quoteDetail.quota_date || ''}
            disabled
          />
        </div>
      </div>

      {/* Cantidad y unidad */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Cantidad</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                className="form-control"
                value={quoteDetail.quantity ?? ''}
                disabled
              />
            </div>
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                value={quoteDetail.quantity_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Almacén */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Almacén</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={quoteDetail.depot}
            disabled
          />
        </div>
      </div>

      {/* Precio Unitario Venta */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Precio Unitario Venta</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-4">
              <input
                type="number"
                className="form-control"
                value={quoteDetail.unit_price ?? ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={quoteDetail.currency || ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={quoteDetail.rate_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Datos de Almacenamiento y Tarifas */}
      {/* Días libres */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Días libres</label>
        <div className="col-md-9">
          <input
            type="number"
            className="form-control"
            value={quoteDetail.free_days ?? ''}
            disabled
          />
        </div>
      </div>


      {/* Comentarios */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Comentarios</label>
        <div className="col-md-9">
          <textarea
            className="form-control"
            value={quoteDetail.comment || ''}
            disabled
          />
        </div>
      </div>
    </>
  );
};

export default WarehouseQuoteDetailShowForm;
